export default __webpack_public_path__ + "static/media/Cerulean_Fall_LE.76c77417.jpg";